export const mapExporterFormResponse = (formData) => {

  return {
    processingId: formData.processingId,
    value: formData.exporterMasterId,
    exporterMasterId: formData.exporterMasterId,
    exporterTrackingNo: formData.exporterTrackingNo,
    exporterCreatedBy: formData.exporterCreatedBy || null,
    exporterJobNumber: formData.exporterJobNumber,
    exportJobDate: formData.exportJobDate,
    exportJobReceivedOn: formData.exportJobReceivedOn,
    exporterJobFillingMode: formData.exporterJobFillingMode,
    exporterJobFillingType: formData.exporterJobFillingType,
    exportTransportMode: formData.exportTransportMode,
    exportCustomHouse: formData.exportCustomHouse,
    exportJOBOwner: formData.exportJOBOwner,
    exportLoadingPortId: formData.exportLoadingPortId?.id,
    exportSBType: formData.exportSBType,
    exportConsignmentType: formData.exportConsignmentType,
    exportStandardDocuments: formData.exportStandardDocuments,
    exportStatus: formData.exportStatus,
    exportLockStatus: formData.exportLockStatus,
    exportEntryDate: formData.exportEntryDate,
    exporterName: formData.exporterId.name,
    exporterId: formData.exporterId,
    exporterAddressId: formData.exportAddressId?.id,
    exporterAddress: formData.exportAddressId?.name,
    exportBranchSerialNumber: formData.exportBranchSerialNumber,
    State: formData.exportState,
    exportIECodeNumber: formData.exportIECodeNumber,
    exportRegistrationType: formData.exportRegistrationType,
    exportRegistrationNumber: formData.exportRegistrationNumber,
    exportDBKBank: formData.exportDBKBank,
    exportDBKAccountNumber: formData.exportDBKAccountNumber,
    exportDBKEDIAccountNumber: formData.exportDBKEDIAccountNumber,
    exportConsigneeId: formData.exportConsigneeId,
    exportConsigneeAddressId: formData.exportConsigneeAddressId?.id,
    exportConsigneeAddress: formData.exportConsigneeAddressId?.name,
    exportConsigneeCountryId: formData.exportConsigneeCountryId,
    isExportBuyerOtherthanConsignee: formData.isExportBuyerOtherthanConsignee,
    exportRefType: formData.exportRefType,
    exportRefNumber: formData.exportRefNumber,
    exportReferenceDate: formData.exportReferenceDate,
    exportType: formData.exportType,
    exportSBNumber: formData.exportSBNumber,
    exportSBNumberDate: formData.exportSBNumberDate,
    exportRBIApprovalNumber: formData.exportRBIApprovalNumber,
    exportRBIApprovalDate: formData.exportRBIApprovalDate,
    exportRBIWaiverNumber: formData.exportRBIWaiverNumber,
    exportRBIWaiverDate: formData.exportRBIWaiverDate,
    exportGRNumber: formData.exportGRNumber,
    exportGRDate: formData.exportGRDate,
    isExportGRWaived: formData.isExportGRWaived,
    exportBankorDealer: formData.exportBankorDealer,
    exportAccountNumber: formData.exportAccountNumber,
    exportADCode: formData.exportADCode,
    exportEPZCode: formData.exportEPZCode,
    exportNotifyId: formData.exportNotifyId,
    exportNotifyAddressId: formData.exportNotifyAddressId?.id,
    NotifyAddressLine: formData.exportNotifyAddress?.name,
    exportSalesPersons: formData.exportSalesPersons,
    exportSalesPerson: formData.exportSalesPerson,
    exportQuotation: formData.exportQuotation,
    isInvoiceAvailable: formData.isInvoiceAvailable || false,
  };
};

// filter
export const mapDashboardFilter = (data) => {
  if (!data) return { filter: {} };

  const mapped = {
    filter: {
      exportTransportMode: data.mode || "",
      exporterJobFillingMode: data.fillingMode || "",
      exporterName: data.exporterSearch || "",
      exportCustomHouse: data.customsMode || "",
      exportSBType: data.sbType || "",
      exportLoadingPort: data.loadingPort || "",
      exportDestinationPort: data.destinationPort || "",
      isActive: data.active ?? "",
      Status: data.status || "",
      dateRange: {
        from: data.dateRange?.[0] || "",
        to: data.dateRange?.[1] || "",
      },
      dynamicFilter: {
        key: data.dynamicKey || "",
        value: data.dynamicValue || "",
      },
    },
  };


  return mapped;
};

export const mapCustomerResponse = (resp) => {
  return {
    id: { id: resp.customerId, name: resp.customerName },
    name: resp.customerName,
    aliseName: resp.aliseName,
    description: resp.userTypes
      ?.map((u) => u.name)
      .join(", ") || "", 
    ieCodeNo:resp.ieCodeNo,
    regNo : resp.regNo,
    branchNo : resp.branchNo
  };
};

// map backend -> frontend
export const mapExporterResponse = (resp) => {
  return {
    id: { id: resp.customerId, name: resp.customerName },
    name: resp.customerName,
    address:
      resp.addresses?.map((addr, index) => {
        const fullAddress = [
          addr.customerAddressLine,
          addr.cityName,
          addr.stateName,
          addr.postalCode ?? addr.customerAddressPostalCode,
          addr.countryName,
        ]
          .filter(Boolean)
          .join(", ");
        return {
          branchName: addr.customerBranchName,
          branchNo: index + 1,
          value: addr.customerAddressId,
          label: addr.stateName ?? fullAddress,
          city: {
            id: addr.cityId,
            name: addr.cityName,
          },
          state: {
            id: addr.stateId,
            name: addr.stateName,
          },
          pincode: addr.postalCode ?? addr.customerAddressPostalCode,
          country: {
            id: addr.countryId,
            name: addr.countryName,
          },
          addressLine: addr.customerAddressLine,
          fullAddress,
        };
      }) ?? [],
    ieCodeNumber: resp.ieCodeNumber ?? "-",
  };
};

export const mapCustomerAddressResponse = (resp) => {
  return {
       id: { id: resp[0]?.customerId?.id, name: resp[0]?.customerId?.name },
    name: resp[0]?.customerId?.name,
    address: resp?.map((addr, index) => {
      return {
        branchName: addr.customerBranchName,
        value: addr.customerAddressId,
        label: addr.stateId?.name,
        city: {
          id: addr.cityId?.id,
          name: addr.cityId?.name,
        },
        state: {
          id: addr.stateId?.id,
          name: addr.stateId?.name,
        },
        pincode: addr.customerAddressPostalCode,
        country: {
          id: addr.countryId?.id,
          name: addr.countryId?.name,
        },
        addressLine: addr.customerAddressLine,
      };
    }) ?? [],
    ieCodeNumber: resp.ieCodeNumber ?? "-",
  };
};



export const mapExporterRequest = (formData) => {


  const exporterMasterFields = [
    "exporterJobNumber",
    "exportJobDate",
    "exportJobReceivedOn",
    "exporterJobFillingMode",
    "exporterJobFillingType",
    "exportTransportMode",
    "exportCustomHouse",
    "exportJOBOwner",
    "exportLoadingPortId",
    "exportSBType",
    "exportConsignmentType",
    "exportStandardDocuments",
    "exporterTrackingNo",
    "jobStatus",
    "exportStatus",
    "exportLockStatus",
    "exportEntryDate",
    "exportUpdateDate",
    "exporterUpdatedBy",
    "exporterCreatedBy",
  ];

  const exporterFields = [
    "exporterMasterId",
    "exportADCode",
    "exportAccountNumber",
    "exportBankorDealer",
    "exportBranchSerialNumber",
    "exportConsigneeId",
    "exportConsigneeAddressId",
    "exportDBKAccountNumber",
    "exportDBKEDIAccountNumber",
    "exportDBKBank",
    "exportEPZCode",
    "exportNotifyId",
    "exportNotifyAddressId",
    "exportQuotation",
    "exportRBIApprovalDate",
    "exportRBIApprovalNumber",
    "exportRBIWaiverNumber",
    "exportRefType",
    "exportRefNumber",
    "exportReferenceDate",
    "exportRegistrationNumber",
    "exportRegistrationType",
    "exportSBNumber",
    "exportSBNumberDate",
    "exportSalesPerson",
    "exportType",
    "exporterAddressId",
    "exporterId",
    "isExportBuyerOtherthanConsignee",
    "isExportGRWaived",
    "exportGRNumber",
    "exportConsigneeCountryId",
    "exporterAddress",
    "notifyAddress",
    "exportConsigneeAddress",
    "exportGRDate",
    "exportRBIWaiverDate"
  ];

  const buildObject = (fields) =>
    fields.reduce((acc, key) => {
      if (formData[key] !== undefined && formData[key] !== null) {
        acc[key] = formData[key];
      }
      return acc;
    }, {});

  const payload = {
    exportJob: {
      processingId: formData.processingId || "",
      exporterMaster: buildObject(exporterMasterFields),
      exporter: buildObject(exporterFields),
    },
  };

  return payload;
};


// {
//             "customerAddressId": "690d9f06e8041cff971c3597",
//             "customerBranchName": "YeeJai Technologies - Chennai Branch",
//             "customerAddressLine": "Old no. 15(4), New no. 57 Perkinspuram 2nd Street,Near New Bus Stand, Aruppukottai, Virudhunagar",
//             "customerAddressTelephone": "+91 44 2345 6789",
//             "customerAddressWebsite": "https://yeejai.com",
//             "customerAddressEmailAddress": "branch@yeejai.com",
//             "customerAddressSalesPerson": "Ravi Kumar",
//             "customerAddressCollectionExec": "Priya Sharma",
//             "customerAddressTaxableType": "GST Registered",
//             "customerAddressFax": "+91 44 9876 5432",
//             "customerAddressIsDeactivate": false,
//             "customerAddressIsSetAsDefault": true,
//             "customerAddressPostalCode": "626 101",
//             "customerAddressLOBWise": "Sea Export",
//             "customerAddressStatus": "Y",
//             "customerAddressCreatedBy": "6902eac4068976ca8551e944",
//             "customerAddressEntryDate": "07-11-2025 07:25:57",
//             "customerAddressUpdatedBy": "68bd525d89b360ac4151e944",
//             "customerAddressUpdateDate": "20-11-2025 05:55:50",
//             "customerId": {
//                 "id": "690b2989611bfa7e2e4535a7",
//                 "name": "ABC Technologies"
//             },
//             "country": {
//                 "id": "685a3b2fc4a49787ad9c0c3e",
//                 "name": "Holy See"
//             },
//             "state": {
//                 "id": "685d170f946716bbf1bd680d",
//                 "name": "Jammu & Kashmir"
//             },
//             "city": {
//                 "id": "690312eafc252944f4baa8c3",
//                 "name": "Blowing Point Village"
//             }
//         },
//         {
//             "customerAddressId": "690cac08c07bbb54dff70403",
//             "customerBranchName": "YeeJai Technologies - Chennai Branch",
//             "customerAddressLine": "Old no. 15(4), New no. 57 Perkinspuram 2nd Street,Near New Bus Stand, Aruppukottai, Virudhunagar",
//             "customerAddressTelephone": "+91 44 2345 6789",
//             "customerAddressWebsite": "https://yeejai.com",
//             "customerAddressEmailAddress": "branch@yeejai.com",
//             "customerAddressSalesPerson": "Ravi Kumar",
//             "customerAddressCollectionExec": "Priya Sharma",
//             "customerAddressTaxableType": "GST Registered",
//             "customerAddressFax": "+91 44 9876 5432",
//             "customerAddressIsDeactivate": false,
//             "customerAddressIsSetAsDefault": true,
//             "customerAddressPostalCode": "626 101",
//             "customerAddressLOBWise": "Sea Export",
//             "customerAddressStatus": "Y",
//             "customerAddressCreatedBy": "6902eac4068976ca8551e944",
//             "customerAddressEntryDate": "06-11-2025 14:09:12",
//             "customerAddressUpdatedBy": "6902eac4068976ca8551e944",
//             "customerAddressUpdateDate": "06-11-2025 14:09:12",
//             "customerId": {
//                 "id": "690b2989611bfa7e2e4535a7",
//                 "name": "ABC Technologies"
//             },
//             "country": {
//                 "id": "685a3b2fc4a49787ad9c0c3e",
//                 "name": "Holy See"
//             },
//             "state": {
//                 "id": "685d170f946716bbf1bd680d",
//                 "name": "Jammu & Kashmir"
//             },
//             "city": {
//                 "id": "690312eafc252944f4baa8c3",
//                 "name": "Blowing Point Village"
//             }
//         }